import { createStore } from '@stencil/store';

export interface Translations {
  [key: string]: string;
}

export enum Labels {
  'Generic.Return' = 'Generic.Return',
  'Generic.Overview' = 'Generic.Overview',
  'Generic.More' = 'Generic.More',
  'Generic.Settings' = 'Generic.Settings',
  'Navigation.LinkTargetBlank' = 'Navigation.LinkTargetBlank',
  'LandingZone.SapLogo' = 'LandingZone.SapLogo',
  'Navigation.MainLinks' = 'Navigation.MainLinks',
  'Navigation.OpenMenu' = 'Navigation.OpenMenu',
  'Navigation.CloseMenu' = 'Navigation.CloseMenu',
  'Search' = 'Search',
  'Search.Open' = 'Search.Open',
  'Search.Cancel' = 'Search.Cancel',
  'Search.Close' = 'Search.Close',
  'Search.Submit' = 'Search.Submit',
  'Search.Results.Profile.AdditionalSearch.Title' = 'Search.Results.Profile.AdditionalSearch.Title',
  'Search.Results.Profile.AdditionalSearch.Body' = 'Search.Results.Profile.AdditionalSearch.Body',
  'ShoppingCart' = 'ShoppingCart',
  'CountrySelector' = 'CountrySelector',
  'CountrySelector.BackToRegions' = 'CountrySelector.BackToRegions',
  'CountrySelector.ChooseRegion' = 'CountrySelector.ChooseRegion',
  'CountrySelector.ChooseCountry' = 'CountrySelector.ChooseCountry',
  'CountrySelector.ChooseLanguage' = 'CountrySelector.ChooseLanguage',
  'CountrySelector.LastVisited' = 'CountrySelector.LastVisited',
  'CountrySelector.FlagIconAltText' = 'CountrySelector.FlagIconAltText',
  'Notifications' = 'Notifications',
  'Notifications.Bell' = 'Notifications.Bell',
  'ContactUs' = 'ContactUs',
  'Loading.Text' = 'Loading.Text',
  'Profile' = 'Profile',
  'Profile.MyAccount' = 'Profile.MyAccount',
  'Profile.Logout' = 'Profile.Logout',
  'Profile.Login' = 'Profile.Login',
  'Profile.CreateUniversalId' = 'Profile.CreateUniversalId',
  'Profile.UserAvatar' = 'Profile.UserAvatar',
  'Profile.MessageClose' = 'Profile.MessageClose',
  'Profile.NewNotifications' = 'Profile.NewNotifications'
}

const fallbackTranslations: Translations = {
  'Generic.Return': 'Return',
  'Generic.Overview': 'Overview',
  'Generic.More': 'More',
  'Generic.Settings': 'Settings',
  'Navigation.LinkTargetBlank': 'opens in a new tab',
  'LandingZone.SapLogo': 'SAP Logo',
  'Navigation.MainLinks': 'Main links',
  'Navigation.OpenMenu': 'Open menu',
  'Navigation.CloseMenu': 'Close menu',
  Search: 'Search',
  'Search.Open': 'Open search',
  'Search.Cancel': 'Cancel search',
  'Search.Close': 'Close search input',
  'Search.Submit': 'Submit search',
  'Search.Results.Profile.AdditionalSearch.Title': 'Additional Searches',
  'Search.Results.Profile.AdditionalSearch.Body': 'Search Community Content for ',
  ShoppingCart: 'Shopping cart',
  CountrySelector: 'Country Selector',
  'CountrySelector.BackToRegions': 'Back to region list',
  'CountrySelector.ChooseRegion': 'Choose your Region',
  'CountrySelector.ChooseCountry': 'Choose your Country',
  'CountrySelector.ChooseLanguage': 'Choose your Language',
  'CountrySelector.LastVisited': 'Last visited',
  'CountrySelector.FlagIconAltText': 'Country flag',
  Notifications: 'Notifications',
  'Notifications.Bell': 'Notification Bell',
  ContactUs: 'Contact Us',
  'Loading.Text': 'loading',
  Profile: 'Profile',
  'Profile.MyAccount': 'My Account',
  'Profile.Logout': 'Log Out',
  'Profile.Login': 'Log In',
  'Profile.CreateUniversalId': 'Create Universal ID',
  'Profile.UserAvatar': 'user avatar',
  'Profile.MessageClose': 'Close message',
  'Profile.NewNotifications': 'new notifications'
};

export const translate = (label: Labels) => {
  return state?.[label] || fallbackTranslations[label] || label;
};

export const setTranslations = (translations: Translations) => {
  reset();

  if (!translations) {
    return null;
  }
  const labels = Object.keys(translations);

  labels.forEach((label) => {
    set(label, translations[label]);
  });
};

const { state, set, reset, dispose } = createStore(fallbackTranslations);

export default state;
export { dispose };
